import React from 'react'

import styles from './styles.module.css'

const Spinner: React.FC = () => (
  <div className={styles.container}>
    <div className={styles.spinner} />
  </div>
)

export default Spinner
